import i18n from "@/i18n";

const FontSizeWithInput = function (editor: any) {
    var fontSizes = [
        12, 14, 16, 20, 24, 28, 36, 48, 60, 72, 96, 112
    ];

    var activeVal = "";
    var input: any;
    editor.ui.registry.addMenuButton("FontSizeWithInput", {
        text: "CustomFontBtn",
        fetch: function (callback: any) {
            var items = [];
            for (let index = 0; index < fontSizes.length; index++) {
                items.push({
                    type: "togglemenuitem",
                    text: fontSizes[index] + "px",
                    onAction: function () {
                        activeVal = fontSizes[index] + "px";
                        (window as any).tinymce.execCommand("FontSize", false, fontSizes[index] + "px");
                        input.value = activeVal;
                    },
                    onSetup: function (api: any) {
                        if (activeVal === fontSizes[index] + "px") api.setActive(true);
                        else api.setActive(false);
                    }
                });
            }

            callback(items);
        },
        onSetup: function () {
            var button = [...document.querySelectorAll("button")].filter(a => a.textContent!.includes("CustomFontBtn"))[0];
            var parent = button.parentElement;

            if (button !== null && button !== undefined) {
                if (!button.parentElement!.className.includes("custom-font-size")) {
                    var wrap = document.createElement("div");
                    wrap.className += "custom-font-size";
                    wrap.title = i18n.t("htmlEditor.fontSize").toString();
                    wrap.appendChild(button);
                    if (parent !== null && parent !== undefined) {
                        parent.appendChild(wrap);
                    }

                    var container = button.parentElement!;
                    var inputElement = document.createElement("input");
                    inputElement.spellcheck = false;
                    inputElement.type = "text";
                    inputElement.className += "customInput";
                    container.appendChild(inputElement);

                    input = container.getElementsByClassName("customInput")[0];

                    input.onchange = function () {
                        var value = input.value;

                        if (value !== undefined) {
                            value = value.toString().toLowerCase();
                            var numbersStrippedFromValue = value.replace(/\d+/g, "");

                            // Default to pixels if no unit is specificed
                            if (numbersStrippedFromValue === "") {
                                value += "px";
                            }

                            (window as any).tinymce.activeEditor.execCommand("FontSize", false, value);
                            activeVal = value;
                            input.value = value;
                        }
                    };

                    input.onfocus = function () {
                        input.select();
                        input.parentNode.classList.add("vsMceSelected");
                    };

                    input.onblur = function () {
                        input.parentNode.classList.remove("vsMceSelected");
                    };

                    editor.on("SelectionChange", function () {
                        var selectSize = editor.queryCommandValue("fontSize");
                        if (activeVal.toLowerCase() !== selectSize) {
                            activeVal = selectSize;
                            input.value = selectSize;
                        }
                    });
                }
            }
        }
    });
};

export { FontSizeWithInput };
